<template>
	<div class="message-compose">
		<div class="message-compose__wrapper">
			<header class="message-compose__header">
				<h3 class="message-compose__title">
					<AppIcon
						class="back-icon"
						icon-name="arrowLeft"
						@click="$emit('back')"
					/>

					Compose Message
				</h3>

				<div class="message-compose__to">
					<label>To</label>
					<CustomTagsInput
						:items="selectedEmails"
						:value="searchValue"
						placeholder="Enter email address"
						@remove="removeEmail($event)"
						@input="inputEmail($event)"
						@enter="selectEmail($event)"
						@click="toggleList()"
					>
					</CustomTagsInput>

					<DropdownList
						v-if="showList"
						:items="emailList"
						:is-searchable="false"
						:is-loading="emailListLoading"
						@select="selectEmail($event.email)"
					>
						<template #default="{ item: {name, email} }">
							<div :class="{ 'selected': selectedEmails.includes(email) }">
								<p>{{ name }}</p>
								<p>{{ email }}</p>
							</div>
						</template>
					</DropdownList>
				</div>

				<AppTextField
					class="message-compose__subject"
					placeholder="Enter subject"
					v-model="email.subject"
				>
					Subject
				</AppTextField>
			</header>

			<!-- <AppTextarea
			class="message-compose__message"
			placeholder="Enter message here"
			v-model="email.message"
		>
			Message
		</AppTextarea> -->
			<div class="message-compose__message">
				<AppTextEditor
					v-model="email.message"
					@image-added="handleImageAdded"
				/>
				<div
					v-show="loading"
					class="message-compose__loading"
				>
					<AppLoading/>
				</div>
			</div>

			<div class="message-compose__footer">
				<div class="message-compose__attachment">
					<MessageAttachment v-for="(item, key) in attachments" :key="key" @remove="removeAttachment(item, key)">
						{{ item.original_name }}
					</MessageAttachment>
				</div>
				<AppFileInput
					:value="null"
					@input="addAttachment"
					:disabled="loading"
				>
					<AppIcon
						class="icon attachment"
						icon-name="clip"
					/>
				</AppFileInput>
				<AppButton
					modifier="icon small-secondary"
					@click="sendEmail"
					:disabled="loading"
				>
					<AppIcon
						class="icon"
						icon-name="send"
					/>
				</AppButton>
				<AppButton
					modifier="small-danger"
					@click="discard"
					:disabled="disableDiscard"
				>
					Discard
				</AppButton>
			</div>
		</div>
	</div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import DropdownList from '@/components/messages/DropdownList.vue'
import CustomTagsInput from '@/components/messages/CustomTagsInput.vue'
import MessageAttachment from '@/components/messages/MessageAttachment.vue'

export default {
	data () {
		return {
			showList: false,
			isListSearchable: true,
			searchValue: ''
		}
	},

	created () {
		this.searchEmail()
	},

	computed: {
		...mapFields('message', {
			email: 'email',
			selectedEmails: 'selectedEmails',
			emailList: 'emailList',
			emailListLoading: 'emailListLoading',

			tempFiles: 'tempFiles',
			attachments: 'attachments',
			deletedAttachments: 'deletedAttachments',
			loading: 'buttonLoading'
		}),

		disableDiscard () {
			return !this.selectedEmails.length &&
			!this.email.subject &&
			!this.email.message &&
      !this.tempFiles.length &&
      !this.attachments.length &&
      !this.deletedAttachments.length
		}
	},

	methods: {
		async addAttachment (files) {
			const file = files[0]
			var form = new FormData()
			form.append('type', 'admin')
			form.append('file', file)
			form.append('module', 'email')
			form.append('original_name', file.name)
			await this.$store.dispatch('message/addAttachment', form)
		},

		removeAttachment (item, index) {
			this.attachments.splice(index, 1)
			this.deletedAttachments.push(item)
		},

		sendEmail () {
			const { subject, message } = this.email

			if (subject.trim() === '' ||
				message.trim() === '' ||
				!this.selectedEmails.length) {
				this.$store.dispatch('toggleBanner', {
					status: true,
					message: 'Please complete input fields.',
					type: 'invalid'
				})
				return
			}

			let deletedImages = this.deletedAttachments.map(i => i.server_name)

			this.tempFiles.forEach(i => {
				if (message.indexOf(i.server_name) === -1) {
					deletedImages.push(i.server_name)
				}
			})

			const form = new FormData()
			form.append('subject', subject)
			form.append('message', message)
			form.append('deleted_image', deletedImages.join())
			form.append('attachment', this.attachments.map(i => i.server_name).join())

			this.selectedEmails.forEach((email, index) => {
				form.append(`emails[${index}]`, email)
			})

			this.$store.dispatch('message/send', form)
		},

		inputEmail (keyword) {
			keyword ? this.showList = true : this.showList = false
			this.isListSearchable = false

			this.searchEmail(keyword)
		},

		searchEmail (keyword = '') {
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.$store.dispatch('message/getEmailList', keyword)
			}, 500)
		},

		selectEmail (email) {
			const index = this.selectedEmails.indexOf(email)
			if (index > -1) {
				this.selectedEmails.splice(index, 1)
				return
			}

			this.selectedEmails.push(email)
			this.searchValue = ''
			this.showList = false
		},

		removeEmail (email) {
			const index = this.selectedEmails.indexOf(email)
			if (index > -1) this.selectedEmails.splice(index, 1)
		},

		toggleList () {
			this.showList = !this.showList
			this.isListSearchable = true
		},

		async handleImageAdded ({ file, Editor, cursorLocation, resetUploader }) {
			var form = new FormData()
			form.append('type', 'admin')
			form.append('file', file)
			form.append('module', 'email')
			form.append('original_name', file.name)
			await this.$store.dispatch('message/tempUpload', form)
			const { path, server_name } = this.tempFiles[this.tempFiles.length - 1]
			const url = `${path}${server_name}`
			Editor.insertEmbed(cursorLocation, 'image', url)
			resetUploader()
		},

		async discard (changePage = false, callback = () => {}) {
			let images = this.tempFiles.map(i => i.server_name)
			let files = this.attachments.map(i => i.server_name)
			let deletedFiles = this.deletedAttachments.map(i => i.server_name)
			let form = new FormData()
			form.append('deleted_image', [...images, ...files, ...deletedFiles])

			if (this.disableDiscard) await this.$store.dispatch('message/discard', { form, changePage, callback })
			else {
				this.$store.commit('toggleModal', {
					modalName: 'discard-message',
					confirm: async () => {
						await this.$store.dispatch('message/discard', { form, changePage, callback })
						await this.$store.dispatch('closeModal')
					}
				})
			}
		}

	},

	components: {
		DropdownList,
		CustomTagsInput,
		MessageAttachment
	}
}
</script>

<style lang="scss" scoped>
.message-compose {
	min-height: 100%;
	padding: 1em;
	background-color: #f5f6f8;

	&__wrapper {
		min-height: 100%;
		width: 100%;
		max-width: 800px;
		padding: 1em;
		display: flex;
		flex-direction: column;
		background-color: #fff;
	}

	&__header {
		margin-bottom: 10px;
	}

	&__title {
		.back-icon {
			width: 0.8em;
			height: 0.8em;
			cursor: pointer;
			margin-right: 1em;
		}

		padding: 10px 0;
	}

	&__to {
		position: relative;
		margin-bottom: 1em;

		label {
			display: block;
			margin-bottom: 0.5em;
			color: $dark;
			width: 100%;
		}

		.tags-input {
			display: inline-flex;
			min-width: 300px;
			overflow: auto;
			max-height: 150px;
		}

		.dropdown-list {
			position: absolute;
			top: 100%;
			left: 0;
			padding: 0;
			min-width: 200px;
			margin-top: 10px;

			&:after {
				position: absolute;
				content: "";
				left: 10px;
				top: -6px;
				border: 1px solid;
				border-color: $light $light transparent transparent;
				display: inline-block;
				height: 10px;
				width: 10px;
				background-color: #fff;
				transform: rotateZ(-45deg);
				pointer-events: none;
			}

			/deep/ .item {
				padding: 5px 10px;

				.selected {
					color: $primary;
				}
			}
		}
	}

	&__subject {
		min-width: 300px;
		margin-bottom: 1em;
	}

	&__message {
		flex: 1 1 auto;
		padding-bottom: 50px;
		height: 300px;
		width: 100%;
		position: relative;
	}

	&__loading {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		background-color: #eee;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0.5;
	}

	&__footer {
		display: flex;
		align-items: center;
		padding: 10px 0;

		> * {
			margin-left: 10px;

			&:not(:first-child) {
				margin-bottom: 5px;
			}
		}
		.icon {
			width: 15px;
			height: 15px;
			&.attachment {
				color: $secondary;
			}
		}
	}

	&__attachment {
		flex: 1 1 auto;
		display: flex;
		justify-content: flex-start;
		overflow: auto;
		padding-bottom: 5px;

		> * {
			flex-shrink: 0;

			&:not(:first-child) {
				margin-left: 5px;
			}
		}
	}
}
</style>
